import { useEffect } from 'react';

import { pubSub } from 'utils/pubSub';

/**
 * Re-reads the Search baseline when the websocket saga reports that presence
 * may have drifted. Pass a trigger that fetches fresh — the lazy query with
 * `preferCacheValue` left off — so nothing is served from the RTK cache.
 */
export const usePresenceSearchResync = (refetch: () => void): void => {
  useEffect(
    () => pubSub.subscribe('presenceSearchResyncRequired', refetch),
    [refetch],
  );
};
